'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification = require('./notification');

Object.defineProperty(exports, 'Notification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notification).default;
  }
});

var _notificationStack = require('./notificationStack');

Object.defineProperty(exports, 'NotificationStack', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notificationStack).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-notification/dist/index.js
// module id = 110
// module chunks = 0